import * as action_types from "./constants";

const initialState = {
  isLoadingTenantDetails: false,
  tenantDetailsError: null,
  tenantData: {},
  leaseData: {},
  dependants: {},
};

export default (state = initialState, action) => {
  const { type, data, error } = action;

  switch (type) {
    case action_types.GET_TENANT_DETAILS_REQUEST:
      return { ...state, isLoadingTenantDetails: true, tenantDetailsError: null };
    case action_types.GET_TENANT_DETAILS_SUCCESS:
      return { ...state, tenantData: data, isLoadingTenantDetails: false };
    case action_types.GET_TENANT_DETAILS_FAILURE:
      return { ...state, isLoadingTenantDetails: false, tenantDetailsError: error };

    case action_types.GET_TENANT_LEASE:
      return { ...state, leaseData: data };
    case action_types.GET_DEPENDENTS:
      return { ...state, dependants: data };
    case action_types.GET_EMPTY:
      return { initialState };

    default:
      return state;
  }
};
